import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../../constants/breakpoints";
import { colors } from "../../../../constants/colors";

const styles = createUseStyles(theme => ({
  usedGrid: {
    border: "none",
    borderTop: "1px solid" + colors.lightGrey,
    boxShadow: "none",
    borderRadius: 0,
    marginBottom: "-48px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "0 -32px -32px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "0 -16px -16px",
    },
    "& .rdt_TableCell": {
      paddingLeft: "24px",
      paddingRight: "24px",
      minWidth: "155px",
      "& div": {
        color: colors.mediumGrey,
        fontWeight: 400,
        whiteSpace: "inherit !important"
      },
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    "& .rdt_TableCol": {
      color: colors.mediumGrey,
      paddingLeft: "24px",
      paddingRight: "24px",
      minWidth: "155px",
      whiteSpace: "nowrap",
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    "& .rdt_TableCell:last-child": {
      paddingRight: "24px !important",
      marginRight: 0
    },
  },
  link: {
    textDecoration: "none",
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "20px",
    color: colors.lightBlack
  },
  expiringSoon: {
    color: `${colors.warning600} !important`,
  },
  helpIcon: {
    width: "16px",
    height: "16px",
    marginLeft: "4px",
    cursor: "pointer",
    "& path": {
      stroke: colors.paleGrey,
    },
    "&:hover": {
      "& path": {
        stroke: colors.inactiveGrey
      }
    },
  },
  tooltip: {
    "& .tooltip-inner": {
      maxWidth: "400px !important",
      padding: "8px 12px",
      fontSize: "12px",
      fontWeight: 600,
      textAlign: "left"
    }
  },
}));

export default styles;
